import React, { useState } from "react";
import "../RecipeGallery.css";

const RecipeGallery = ({ galleryImages }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const openModal = (src) => {
    setSelectedImage(src);
    setTimeout(() => setIsAnimating(true), 20); // animasyon için kısa gecikme
  };

  const closeModal = () => {
    setIsAnimating(false);
    setTimeout(() => setSelectedImage(null), 300); // animasyon tamamlanınca kaldır
  };

  if (!galleryImages || galleryImages.length === 0) return null;

  return (
    <div className="gallery-section">
      <h3 className="gallery-title">More Delicious Ideas</h3>
      <div className="gallery-grid">
        {galleryImages.map((src, index) => (
          <div key={index} className="gallery-item" onClick={() => openModal(src)}>
            <img src={src} alt={`Dish ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className={`modal-overlay ${isAnimating ? "show" : ""}`} onClick={closeModal}>
          <div
            className={`modal-content ${isAnimating ? "zoom-in" : "zoom-out"}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close" onClick={closeModal}>×</button>
            <img src={selectedImage} alt="Full Size" />
          </div>
        </div>
      )}
    </div>
  );
};

export default RecipeGallery;
